import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from 'react'

interface AudioContextType {
  currentlyPlayingAudioId?: string
  setCurrentlyPlayingAudio: (audioId?: string) => void
  pauseCurrentAudio: () => void
}

const AudioContext = createContext<AudioContextType | undefined>(undefined)

export const AudioProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentlyPlayingAudioId, setCurrentlyPlayingAudioId] = useState<
    string | undefined
  >(undefined)

  const setCurrentlyPlayingAudio = useCallback((audioId?: string) => {
    setCurrentlyPlayingAudioId(audioId)
  }, [])

  const pauseCurrentAudio = useCallback(() => {
    setCurrentlyPlayingAudio(undefined)
  }, [setCurrentlyPlayingAudio])

  const contextValue = useMemo(
    () => ({
      currentlyPlayingAudioId,
      setCurrentlyPlayingAudio,
      pauseCurrentAudio,
    }),
    [currentlyPlayingAudioId, setCurrentlyPlayingAudio, pauseCurrentAudio]
  )

  return (
    <AudioContext.Provider value={contextValue}>
      {children}
    </AudioContext.Provider>
  )
}

export const useAudioContext = () => {
  const context = useContext(AudioContext)
  if (context === undefined) {
    throw new Error('useAudioContext must be used within an AudioProvider')
  }
  return context
}
